import { z } from 'zod'

export const dentalInsuranceSchema = z.object({
  health_insurance_type: z.enum(['mandatory', 'private', 'none']),
  has_existing_dental_insurance: z.boolean(),
  earns_above_threshold: z.boolean(),
})
